import gql from "graphql-tag";

// fragment
export const ENVIRONMENT_FRAGMENT = gql`
    fragment environment on EnvironmentNode {
        id
        environment
        updatedAt
        updatedBy
    }
`;

// all query
export const ENVIRONMENTS_QUERY = gql`
    query {
        tenantEnvironments {
            edges {
                node {
                    ...environment
                }
            }
        }
    }
    ${ENVIRONMENT_FRAGMENT}
`;

// single query
export const SINGLE_ENVIRONMENT_QUERY = gql`
    query environment($id: ID!) {
        environment(id: $id) {
            ...environment
        }
    }
    ${ENVIRONMENT_FRAGMENT}
`;

// create
export const CREATE_ENVIRONMENT_MUTATION = gql`
    mutation createEnvironment($input: CreateEnvironmentInput!) {
        createEnvironment(input: $input) {
            environment {
                ...environment
            }
        }
    }
    ${ENVIRONMENT_FRAGMENT}
`;

// update
export const UPDATE_ENVIRONMENT_MUTATION = gql`
    mutation updateEnvironment($input: UpdateEnvironmentInput!) {
        updateEnvironment(input: $input) {
            environment {
                ...environment
            }
        }
    }
    ${ENVIRONMENT_FRAGMENT}
`;

// delete
export const DELETE_ENVIRONMENT_MUTATION = gql`
    mutation deleteEnvironment($input: DeleteEnvironmentInput!) {
        deleteEnvironment(input: $input) {
            environment {
                ...environment
            }
        }
    }
    ${ENVIRONMENT_FRAGMENT}
`;
